/**
 * 채팅 첨부 다운로드 시 저장 파일명 결정
 * - 원본명 우선(사용자 기대, 정렬·검색에 유리)
 * - 없거나 위험한 문자만 제거 후 짧게 자름
 * - 그다음 URL 경로 마지막 세그먼트, blob/알 수 없으면 image-{n}.jpg
 */

// eslint-disable-next-line no-control-regex
const INVALID_FILE_CHARS = /[<>:"/\\|?*\u0000-\u001F]/g;
const MAX_LEN = 180;

export function sanitizeChatDownloadFileName(name) {
  if (name == null || typeof name !== "string") return "";
  const base = name.replace(/^.*[/\\]/, "").trim();
  const cleaned = base.replace(INVALID_FILE_CHARS, "_").replace(/\s+/g, " ").trim().slice(0, MAX_LEN);
  return cleaned || "";
}

/**
 * @param {string|null|undefined} originalName 서버/업로드 originalName 또는 로컬 File.name
 * @param {string} url 다운로드 URL (blob 포함)
 * @param {number} indexZeroBased 같은 메시지 안에서의 순번
 */
export function pickChatImageDownloadFileName(originalName, url, indexZeroBased = 0) {
  const fromOriginal = sanitizeChatDownloadFileName(originalName);
  if (fromOriginal) return fromOriginal;

  if (typeof url === "string" && url.length > 0) {
    try {
      const u = new URL(url, typeof window !== "undefined" ? window.location.href : undefined);
      const seg = decodeURIComponent(u.pathname.split("/").pop() || "");
      const fromUrl = sanitizeChatDownloadFileName(seg);
      if (fromUrl) {
        if (fromUrl.includes(".")) return fromUrl;
        return `${fromUrl}.jpg`;
      }
    } catch {
      /* ignore */
    }
    if (url.startsWith("blob:")) {
      return `image-${indexZeroBased + 1}.jpg`;
    }
    const tail = sanitizeChatDownloadFileName(url.split("/").pop() || "");
    if (tail) return tail.includes(".") ? tail : `${tail}.jpg`;
  }

  return `image-${indexZeroBased + 1}.jpg`;
}
